import {
  Component,
  ElementRef,
  NgZone, OnInit,
  ViewChild
} from '@angular/core';
import {
  Router,
  Event as RouterEvent,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError
} from '@angular/router';

import { environment } from '../../../environments';
@Component({
  selector: 'prism-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  @ViewChild('spinnerElement')
  spinnerElement: ElementRef;
  showLoader = false;

  constructor(private router: Router, private ngZone: NgZone) {
    this.router.events.subscribe((event: RouterEvent) => {
      this._navigationInterceptor(event);
    });
  }

  ngOnInit() {
  }

  private _navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.ngZone.runOutsideAngular(() => {
        this.showLoader = true;
      });
    }

    if (event instanceof NavigationCancel || event instanceof NavigationEnd) {
      this._hideSpinner();
    }

    if (event instanceof NavigationError) {
      this._hideSpinner();
      localStorage.removeItem(environment.lastVisitedAddressKey);
    }
  }

  private _hideSpinner(): void {
    this.ngZone.runOutsideAngular(() => {
      this.showLoader = false;
    });
  }
}
